<template>
  <div>
    <v-list v-if="times.today.length > 0" dense>
      <v-subheader>Today</v-subheader>
      <v-list-item-group v-model="selectedItem" color="">
        <v-list-item v-for="(item, i) in times.today" :key="item.id || i">
          <v-list-item-icon>
            <v-menu bottom min-width="140" right :offset-x="offset">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on">mdi-dots-horizontal</v-icon>
              </template>
              <v-list>
                <v-list-item @click="deletedFromLocalstorage(item.id)">
                  <v-list-item-icon>
                    <v-icon dark>mdi-delete</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>حذف</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-list-item-icon>
          <v-list-item-content
            @click="setChatAi({ item })"
            style="cursor: pointer"
          >
            <v-list-item-title class="container__aichat_menu_title">{{
              item.title
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>

    <v-list v-if="times.yesterday.length > 0" dense>
      <v-subheader>Yesterday</v-subheader>
      <v-list-item-group v-model="selectedItem" color="">
        <v-list-item v-for="(item, i) in times.yesterday" :key="item.id || i">
          <v-list-item-icon>
            <v-menu bottom min-width="120" right :offset-x="offset">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on">mdi-dots-horizontal</v-icon>
              </template>
              <v-list max-width="200">
                <v-list-item @click="deletedFromLocalstorage(item.id)">
                  <v-list-item-icon>
                    <v-icon dark>mdi-delete</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>حذف</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-list-item-icon>
          <v-list-item-content
            @click="setChatAi({ item })"
            style="cursor: pointer"
          >
            <v-list-item-title
              class="container__aichat_menu_title"
              v-text="item.title"
            ></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>

    <v-list v-if="times.lastMonth.length > 0" dense>
      <v-subheader>Last Month</v-subheader>
      <v-list-item-group v-model="selectedItem" color="">
        <v-list-item v-for="(item, i) in times.lastMonth" :key="item.id || i">
          <v-list-item-icon>
            <v-menu bottom max-height="80" right :offset-x="offset">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on">mdi-dots-horizontal</v-icon>
              </template>
              <v-list>
                <v-list-item @click="deletedFromLocalstorage(item.id)">
                  <v-list-item-icon>
                    <v-icon>mdi-delete</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>حذف</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon color="black">mdi-pencil</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>ویرایش</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-list-item-icon>
          <v-list-item-content
            @click="setChatAi({ item })"
            style="cursor: pointer"
          >
            <v-list-item-title
              class="container__aichat_menu_title"
              v-text="item.title"
            ></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>

    <v-list v-if="times.older.length > 0" dense>
      <v-subheader>Older</v-subheader>
      <v-list-item-group v-model="selectedItem" color="">
        <v-list-item v-for="(item, i) in times.older" :key="item.id || i">
          <v-list-item-icon>
            <v-menu bottom max-height="80" right :offset-x="offset">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on">mdi-dots-horizontal</v-icon>
              </template>
              <v-list>
                <v-list-item @click="deletedFromLocalstorage(item.id)">
                  <v-list-item-icon>
                    <v-icon>mdi-delete</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>حذف</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon color="black">mdi-pencil</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>ویرایش</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-list-item-icon>
          <v-list-item-content
            @click="setChatAi({ item })"
            style="cursor: pointer"
          >
            <v-list-item-title
              class="container__aichat_menu_title"
              v-text="item.title"
            ></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>

    <span v-if="data.length === 0" class="text-center mt-3">empty</span>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import moment from "moment";
import ChatServices from "../../../utilities/ChatServices";

export default {
  name: "list",

  data() {
    return {
      chat: [],
      times: {
        today: [],
        yesterday: [],
        lastWeek: [],
        lastMonth: [],
        older: [],
      },
      data: [],
      chatServices: null,
      selectedItem: null,
      offset: 0, // مقدار دلخواه برای offset-x منو (اگر لازم داری)
    };
  },

  mounted() {
    this.chatServices = new ChatServices();
    this.getListFromApi();
  },

  computed: {
    ...mapState("chatAi", ["ShowMenuAi", "ChatAi"]),
    currentMenu: {
      get() {
        return this.menu;
      },
      set(value) {
        this.$emit("update:menu", value);
      },
    },
  },

  methods: {
    ...mapActions("chatAi", ["setShow", "setChat"]),

    setChatAi({ item }) {
      this.setChat(item);
      this.$toast.success("سوابق چت شما بازگردانده شد");
      this.setShow();
    },

    deletedFromLocalstorage(id) {
      const local = JSON.parse(localStorage.getItem("chatAi")) || [];
      const filtered = local.filter((item) => item.id !== id);
      localStorage.setItem("chatAi", JSON.stringify(filtered));
      this.getListFromApi();
    },

    checkTime() {
      const today = moment().startOf("day");
      const yesterday = moment().subtract(1, "day").startOf("day");
      const lastWeek = moment().subtract(7, "days").startOf("day");
      const lastMonth = moment().subtract(1, "month").startOf("day");

      const times = {
        today: [],
        yesterday: [],
        lastWeek: [],
        lastMonth: [],
        older: [],
      };

      this.data.forEach((item) => {
        const dateStr = item.created_at;
        const date = moment(dateStr);
        if (date.isSame(today, "day")) {
          times.today.push(item);
        } else if (date.isSame(yesterday, "day")) {
          times.yesterday.push(item);
        } else if (date.isAfter(lastWeek)) {
          times.lastWeek.push(item);
        } else if (date.isAfter(lastMonth)) {
          times.lastMonth.push(item);
        } else {
          times.older.push(item);
        }
      });

      this.times = times;
    },

    getListFromApi() {
      this.chatServices.getAllArchiveChats().then(({ data }) => {
        this.data = data.data || [];
        this.checkTime();
      });
    },
  },
};
</script>

<style scoped>
.container__aichat_menu_title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 180px;
  display: block;
  cursor: pointer;
}
.text-center {
  text-align: center;
}
.mt-3 {
  margin-top: 1rem;
}
</style>
